const test = {};

test.callback=function (fn){
    if(fn){
        fn('==回调测试==')
    }
}

export default test;